import Modal from 'components/_parts/atoms/modal';
import 'components/company/revamp/parts/index.scss';
import { useOuterClick } from 'providers/OutsideClick';
import LeftSide from 'components/company/revamp/leftSide';
import RightSide from 'components/company/revamp/rightSide';
import ContentLeft from 'components/company/revamp/contentLeft';
import ContentRight from 'components/company/revamp/contentRight';
import ModalDeleteMember from 'components/layouts/modal/DeleteMember';

function Index({ show, setShow }) {
  const myRef = useOuterClick((e) => {
    if (e.target.className === 'modal_background') {
      setShow(false);
    }
  });

  return (
    <>
      <ModalDeleteMember />
      <Modal modal={show} type="companySetting">
        <div
          ref={myRef}
          className={`new_company_settings_container fade ${show && 'show'}`}
          id="pop_up-parent"
        >
          <LeftSide>
            <ContentLeft />
          </LeftSide>
          <RightSide>
            <ContentRight />
          </RightSide>
        </div>
      </Modal>
    </>
  );
}

export default Index;
